export default __webpack_public_path__ + "static/media/foto sin  foto.5060d2ad.jpg";